import { hysdk } from '../hy-sdk';

export function openOrRedirect(url: string, options?: { target?: string }): void {
  const { isViduApp, os, isLenovoMini } = hysdk.sniff;
  if ((isViduApp && os === 'ios') || isLenovoMini) {
    window.location.href = url;
    return;
  }
  const handle = window.open(url, options?.target || '_blank');
  if (!handle) {
    window.location.href = url;
  }
}
